import React from 'react'

export default function NoneUserIcon(props:any) {

    let iconClass

    switch (props.size) {
        case '22'   : iconClass = "size-22"; break
        case '26'   : iconClass = "size-26"; break
        case '32'   : iconClass = "size-32"; break
        default     :
            return null
    }

    const classes = Classes(iconClass, "gd-user none", props.className);

    return (
        <div className={classes}>
           <div className="initials i5-user"/>
        </div>
    )
}